import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/finally';
import 'rxjs/add/operator/retry';
import 'rxjs/add/operator/timeout';
import {solarAnalyticsSimpleData} from '../model/meter/solarAnalyticsSimpleData';
import {isolarAnalyticsSimpleData} from '../model/meter/isolarAnalyticsSimpleData';
import {ng2ChartJs} from '../model/graphing/ng2chart/ng2ChartJs';
import {highChartSummary} from '../model/graphing/highsoft/highChartSummary';
import {LoggerService} from './logger-service';


@Injectable()
export class SolarAnalyticsData {

  URL: string = 'https://portal.solaranalytics.com.au/api/';
  site_data: string = 'v2/site_data/';
  site_no: string = '140';

  constructor(public http: Http,
              private logger: LoggerService) {
    this.logger.log.debug('Hello SolarAnalyticsData Provider');
  }

  createAuthorizationHeader(headers: Headers) {

      headers.append('Authorization', 'Basic ' +
      btoa('michael.moran@voltio.com.au:Solar31415'));
  }

  getSolarAnalyticsSimpleData(): Observable<solarAnalyticsSimpleData> {
    let url = this.URL + this.site_data + this.site_no;
    this.logger.log.debug('Calling url: '+ url);
    let headers = new Headers();
    this.createAuthorizationHeader(headers);

     return this.http.get(url, { headers: headers})
       .retry(3) //three
       .timeout(150000) //five minutes values - so every two and a half minute
       .map(res => res.json().data as solarAnalyticsSimpleData).finally(() => this.logger.log.debug(url + ' call finished.'));
  }

  getSolarAnalyticsGraphChartHSData(): Observable<highChartSummary> {
    let url = this.URL + this.site_data + this.site_no;
    this.logger.log.debug('Calling url: '+ url);
    let headers = new Headers();
    this.createAuthorizationHeader(headers);

    return this.http.get(url, { headers: headers})
      .retry(3) //three
      .timeout(150000) //five minutes values - so every two and a half minute
      .map(res => res.json().data)
      .map((data: isolarAnalyticsSimpleData[]) => {
        return new highChartSummary(data);
      })
      .finally(() => this.logger.log.debug(url + ' call and object instantiation finished.'));
  }

  //TODO: to remove when we have app store success for android and ios
  getSolarAnalyticsGraphChartJsData(): Observable<ng2ChartJs> {
    let url = this.URL + this.site_data + this.site_no;
    this.logger.log.debug('Calling url: '+ url);
    let headers = new Headers();
    this.createAuthorizationHeader(headers);

    return this.http.get(url, { headers: headers})
      .retry(3) //three
      .timeout(150000) //five minutes values - so every two and a half minute
      .map(res => res.json().data)
      .map((data: isolarAnalyticsSimpleData[]) => {
        return new ng2ChartJs(data);
      })
      .finally(() => this.logger.log.debug(url + ' call and object instantiation finished.'));
  }

  //TODO: retrywhen - exponential backoff - http://blog.danlew.net/2016/01/25/rxjavas-repeatwhen-and-retrywhen-explained/
  //TODO: https://codepen.io/HipsterZipster/pen/eNJNxo
  //TODO: .catch(this.exceptionService.catchBadResponse)
  //TODO: ErrorNotifierService - http://restlet.com/company/blog/2016/04/18/interacting-efficiently-with-a-restful-service-with-angular2-and-rxjs-part-3/


  get(url) {
    url = this.URL + this.site_data + this.site_no;
    this.logger.log.debug('Calling url: '+ url);
    let headers = new Headers();
    this.createAuthorizationHeader(headers);
    return this.http.get(url, { headers: headers })
      .map(res => res.json().data as solarAnalyticsSimpleData[]).subscribe(

      data => {
      this.logger.log.debug(data);
      },
      err => {
        this.logger.log.debug(err);
      },
      () => {
        this.logger.log.debug('call completed: ' + url)
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/providers/solar-analytics-data.ts